import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterRestaurantsList'
})
export class FilterRestaurantsPipe implements PipeTransform {
    transform(restaurants: any, term?: any): any {
        if (term === undefined) return restaurants;
        if (term === null) return restaurants;

        if (restaurants != null) {
            return restaurants.filter(function (restaurant) {
                if (restaurant.name != undefined)
                    if (restaurant.name.toString().toLowerCase().includes(term.toLowerCase()))
                        return restaurant;
                if (restaurant.email != undefined)
                    if (restaurant.email.toString().toLowerCase().includes(term.toLowerCase()))
                        return restaurant;
                if (restaurant.provider != undefined)
                    if (restaurant.provider.toString().toLowerCase().includes(term.toLowerCase()))
                        return restaurant;



            })
        }



    }
}


// WEBPACK FOOTER //
// ./src/pages/auth/filter.pipe.ts